'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

exports.default = withSubtree;

var _identityReducer = require('nanotools/lib/identityReducer');

var _identityReducer2 = _interopRequireDefault(_identityReducer);

var _createSubtreeLifecycleMethods = require('../util/createSubtreeLifecycleMethods');

var _createSubtreeLifecycleMethods2 = _interopRequireDefault(_createSubtreeLifecycleMethods);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function withSubtree(getSubtree) {
	return function (Clazz) {
		return function (_Clazz) {
			(0, _inherits3.default)(_class, _Clazz);

			function _class() {
				var _ref;

				(0, _classCallCheck3.default)(this, _class);

				for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
					args[_key] = arguments[_key];
				}

				var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = _class.__proto__ || (0, _getPrototypeOf2.default)(_class)).call.apply(_ref, [this].concat(args)));

				_this.__subtreeReducer = _identityReducer2.default;
				(0, _assign2.default)(_this, (0, _createSubtreeLifecycleMethods2.default)(getSubtree, (0, _get3.default)(_class.prototype.__proto__ || (0, _getPrototypeOf2.default)(_class.prototype), 'componentWillMount', _this), (0, _get3.default)(_class.prototype.__proto__ || (0, _getPrototypeOf2.default)(_class.prototype), 'componentDidMount', _this), (0, _get3.default)(_class.prototype.__proto__ || (0, _getPrototypeOf2.default)(_class.prototype), 'componentWillUnmount', _this)));
				return _this;
			}

			(0, _createClass3.default)(_class, [{
				key: '__notifyChildren',
				value: function __notifyChildren(state) {
					if (this.__subtreeKeys) {
						var keys = this.__subtreeKeys;
						for (var i = 0, len = keys.length; i < len; i++) {
							this[keys[i]].getSubject().next(state);
						}
					}
				}
			}, {
				key: 'reducer',
				value: function reducer(state, action) {
					var superReducer = (0, _get3.default)(_class.prototype.__proto__ || (0, _getPrototypeOf2.default)(_class.prototype), 'reducer', this);
					var nextState = state;
					// Merge subtree state only if it changes.
					var nextSubtreeState = this.__subtreeReducer(state, action);
					if (nextSubtreeState !== state) {
						nextState = (0, _assign2.default)({}, state, nextSubtreeState);
					}
					// Call superclass reducer.
					return superReducer.call(this, nextState, action);
				}
			}]);
			return _class;
		}(Clazz);
	};
}